<script setup lang="ts">
import type { InfluencingLineDetails } from '../types'
import { useClaimLab } from '../stores/claimLab'

const claimLab = useClaimLab()

const props = defineProps<{
  description?: string
  influencingLines?: InfluencingLineDetails[]
  policyTopic?: string
  policyId?: string
}>()

const policyDetailsUrl = computed(() => {
  if (!claimLab.ripData?.connector.id || !props.policyId) return ''

  return `/policies/${props.policyId}?lob=${claimLab.ripData?.connector.id}&view=analytics&insight_mode=Active%7CObservation`
})
</script>

<template>
  <section class="space-y-4 text-xs leading-6">
    <div v-if="description">
      <h3 class="font-medium">Description</h3>
      {{ description }}
    </div>
    <div v-if="policyTopic">
      <h3 class="font-medium">Policy Topic</h3>
      {{ policyTopic }}
    </div>
    <div v-if="policyDetailsUrl">
      <h3 class="font-medium">Policy ID</h3>
      <div>{{ policyId }}</div>
      <NuxtLink
        :to="policyDetailsUrl"
        class="text-secondary-700 text-xs"
        target="_blank"
      >
        View policy details for this claim line's date of service
      </NuxtLink>
    </div>
    <div v-if="influencingLines && influencingLines.length">
      <h3 class="font-medium">Influencing Claim Lines</h3>
      <ul>
        <li
          v-for="line in influencingLines"
          :key="`${line.claimId}-${line.sequence}`"
        >
          {{ `${line.claimId}, Line ${line.sequence}` }}
        </li>
      </ul>
    </div>
  </section>
</template>
